import React from 'react'
import { NoticeInfo } from '@fs/zion-icon'
import { Toggle, Divider, ToggleGroup, Row, LabelTooltip, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { useHighlightsVisibilityContext } from '../../providers/highlightsVisibilityProvider/HighlightsVisibilityProvider'

/**
 * Renders a control for toggling the visibility of highlights in the shared image viewer.
 *
 * @returns {React.ReactElement | null}
 */
export default function HighlightsControl() {
  const [t] = useTranslation()
  const { toggleChecked, setToggleChecked, disabled } = useHighlightsVisibilityContext()

  const handleChange = ({ target: { checked } }) => {
    setToggleChecked(checked)

    // Track the toggle event for analytics, including the new value of the toggle (checked or unchecked)
    trackEvent({
      event_name: 'click_action',
      link_name: 'show_highlights_toggle',
      link_value: checked,
    })
  }

  return (
    <>
      <Divider label={t('shared-image-viewer.toggle-highlights.label', 'Toggle Highlights')} marginY="xxs" />
      <Row gutters="nano" alignY="bottom">
        <ToggleGroup dense>
          <Toggle
            label={t('shared-image-viewer.highlights', 'Show Highlights')}
            allowLabelWrapping
            name="highlights"
            checked={toggleChecked}
            onChange={handleChange}
            disabled={disabled}
            data-testid="highlights-toggle"
          />
        </ToggleGroup>
        <LabelTooltip
          target={
            <NoticeInfo
              color={colors.blue60}
              aria-label={t(
                'shared-image-viewer.highlights-tooltip',
                'Show or hide boxes highlighting names and other details (when available).'
              )}
            />
          }
          label={t(
            'shared-image-viewer.highlights-tooltip',
            'Show or hide boxes highlighting names and other details (when available).'
          )}
        />
      </Row>
    </>
  )
}
